export enum FormsListRoutes {
  FormsSubmitsList = 'forms-submits-list',
  FormsListManagement = 'forms-list-management',
  FormsInquiresBoard = 'forms-inquires-board',
}
